import { Expose } from "@nts/std/serialization";

export class EnumDataItem {
    
    @Expose()
    enumValue: number;
    
    @Expose()
    enumDisplayName: string;
}